module.exports = __webpack_public_path__ + "static/media/ag-products1.a39542eb.jpg";